import { ItemActionsMenu } from '@/common/components/_misc/ItemActionsMenu';
import type { FileNode } from '@/common/utils/fileTreeUtils';
import { useFileTreeItemActions } from '../hooks/useFileTreeItemActions';

interface FileTreeItemActionsMenuProps {
  node: FileNode;
  projectDirPath?: string | null;
}

export function FileTreeItemActionsMenu({
  node,
  projectDirPath,
}: FileTreeItemActionsMenuProps) {
  const actions = useFileTreeItemActions({ node, projectDirPath });

  return <ItemActionsMenu actions={actions} variant="inline" />;
}
